import type {
  ArtShortSerializer,
  IApiResponse,
  OkResponse_BaseUploadArtByHashSerializer_,
  OkResponse_list_UserUploadSerializer__,
  UserUploadSerializer,
  UserUploadStatusSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

export const uploadApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getUserUploadedArts: build.query<
      IApiResponse<ArtShortSerializer[]>["payload"],
      void
    >({
      query: () => ({
        url: "/foundation/api/users/me/arts/upload",
      }),
      transformResponse: (response: IApiResponse<ArtShortSerializer[]>) =>
        response.payload,
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.MY_BOOKS as const,
                id,
              })),
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST, TagsType.MY_BOOKS],
    }),
    uploadArt: build.mutation<
      OkResponse_list_UserUploadSerializer__,
      {
        file: File;
      }
    >({
      query: ({ file }) => ({
        url: "/foundation/api/users/me/arts/upload",
        method: "POST",
        body: { art: file },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    }),
    uploadArtByHash: build.mutation<
      OkResponse_BaseUploadArtByHashSerializer_,
      {
        hash: string;
      }
    >({
      query: ({ hash }) => ({
        url: `/foundation/api/users/me/arts/${hash}/upload`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    }),
    getUserUploadsStatus: build.query<UserUploadSerializer[], void>({
      query: () => ({
        url: "/foundation/api/users/me/uploads",
      }),
      transformResponse: (response: IApiResponse<UserUploadSerializer[]>) =>
        response.payload.data,
    }),
    getUserUploadStatus: build.query<
      UserUploadStatusSerializer,
      { upload_id: number }
    >({
      query: ({ upload_id }) => ({
        url: `/foundation/api/users/me/uploads/${upload_id}/status`,
      }),
      transformResponse: (response: IApiResponse<UserUploadStatusSerializer>) =>
        response.payload.data,
    }),
  }),
});
